export default __webpack_public_path__ + "static/media/third-screen.cb9a1cb6.png";